import { ColorPresets } from '@/types/whiteboard';
import { Tool } from './Tool';

export class BrushTool extends Tool {
  public static BRUSH_TYPE = {
    BRUSH: 'brush',
    MARK: 'mark',
  };

  public static BRUSH_WIDTH = {
    THIN: 'thin',
    THICK: 'thick',
  };

  public static BRUSH_TYPE_ICON = {
    [BrushTool.BRUSH_TYPE.BRUSH]: 'icon-brush1',
    [BrushTool.BRUSH_TYPE.MARK]: 'icon-marker',
  };

  public title = 'TOOLBAR_BRUSH';

  public icon = BrushTool.BRUSH_TYPE_ICON[BrushTool.BRUSH_TYPE.BRUSH];

  public type = BrushTool.BRUSH_TYPE.BRUSH;

  public width = BrushTool.BRUSH_WIDTH.THIN;

  public color = ColorPresets.BLACK;

  public setAttributes(options: Partial<{ type: string; width: string; color: ColorPresets }>) {
    this.type = options.type ?? this.type;
    this.width = options.width ?? this.width;
    this.color = options.color ?? this.color;
    this.icon = BrushTool.BRUSH_TYPE_ICON[this.type];
  }

  public serialize(): string {
    return JSON.stringify({ type: this.type, width: this.width, color: this.color });
  }

  public get strokewidth(): number {
    return {
      [BrushTool.BRUSH_TYPE.BRUSH]: {
        [BrushTool.BRUSH_WIDTH.THIN]: 3,
        [BrushTool.BRUSH_WIDTH.THICK]: 8,
      },
      [BrushTool.BRUSH_TYPE.MARK]: {
        [BrushTool.BRUSH_WIDTH.THIN]: 9,
        [BrushTool.BRUSH_WIDTH.THICK]: 24,
      },
    }[this.type][this.width];
  }

  public get opacity(): number {
    if (this.type === BrushTool.BRUSH_TYPE.BRUSH) {
      return 1;
    }
    return 0.36;
  }
}

export const brushTool = new BrushTool();
